import { Box, List, ListItem, Radio, Typography, TextField } from '@mui/material';
import { infoModalSxs } from 'src/content/billing/components/newChangePlan';
import { SEOSpaceLocal, infoModalTexts } from 'src/common/config/TextMessage';

interface FeedbackOptionsProps {
  feedbackOptions: string[];
  selectedOption: string | null;
  otherReason: string;
  missingFeature: string;
  isOtherFieldError: boolean;
  isMissingFieldError: boolean;
  isMinCharOtherError: boolean;
  isMinCharMissingError: boolean;
  isLocalSeo: boolean;
  handleToggle: (option: string) => void;
  setOtherReason: (val: string) => void;
  setMissingFeature: (val: string) => void;
  setIsOtherFieldError: (val: boolean) => void;
  setIsMissingFieldError: (val: boolean) => void;
}

const FeedbackOptions = ({
  feedbackOptions, selectedOption, otherReason, missingFeature, isOtherFieldError,
  isMissingFieldError, isMinCharOtherError, isMinCharMissingError, isLocalSeo,
  handleToggle, setOtherReason, setMissingFeature, setIsOtherFieldError, setIsMissingFieldError
}: FeedbackOptionsProps) => {
  return (
    <Box>
      <List>
        {feedbackOptions.map((option) => {
          const isSelected = selectedOption === option;
          const showTextField = (selectedOption === 'Other' || selectedOption === 'Missing Features') && isSelected;
          return (
            <ListItem key={option} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', p: 0, flexDirection: 'column', gap: 0 }} onClick={() => handleToggle(option)}>
              <Box sx={{ border: `1px solid ${isSelected ? 'var(--color-secondary)' : 'var(--color-border-medium)'}`, borderRadius: '6px', display: 'flex', alignItems: 'center', width: '100%' }}>
                <Radio checked={isSelected} sx={{ color: isSelected ? 'var(--color-secondary)' : 'var(--color-border)', '&.Mui-checked': { color: 'var(--color-secondary)' }, '&:hover': { backgroundColor: 'transparent' } }} disableRipple />
                <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'var(--color-primary)' }}>{option}</Typography>
              </Box>
              {showTextField && (
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  sx={{
                    mt: 1,
                    '& .MuiInputBase-root': { borderRadius: '6px', py: '14px' },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor:
                        isOtherFieldError || isMissingFieldError
                          ? 'var(--color-error-dark)'
                          : 'var(--color-text-secondary)'
                    }
                  }}
                  InputProps={{ style: { ...infoModalSxs?.placeHolderText } }}
                  placeholder={
                    selectedOption === 'Other'
                      ? isLocalSeo
                        ? `Tell us why you're canceling to help us improve ${SEOSpaceLocal}`
                        : "Tell us why you're downgrading to help us improve SEOSpace"
                      : isLocalSeo
                      ? `Help us improve ${SEOSpaceLocal} by sharing which features we’re missing`
                      : 'Help us improve SEOSpace by sharing which features we’re missing'
                  }
                  value={selectedOption === 'Other' ? otherReason : missingFeature}
                  onChange={(e) => {
                    const val = e.target.value.slice(0, 200);
                    if (selectedOption === 'Other') {
                      setOtherReason(val);
                      setIsOtherFieldError(false);
                    } else {
                      setMissingFeature(val);
                      setIsMissingFieldError(false);
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  error={
                    (selectedOption === 'Other'
                      ? otherReason?.length
                      : missingFeature?.length) >= 200
                  }
                  helperText={
                    (selectedOption === 'Other'
                      ? otherReason?.length
                      : missingFeature?.length) >= 200
                      ? 'You have reached the maximum limit of 200 characters.'
                      : ''
                  }
                  autoComplete="off"
                />
              )}
              {showTextField && (isOtherFieldError || isMissingFieldError || isMinCharOtherError || isMinCharMissingError) && (
                <Box sx={infoModalSxs?.noSelectionFieldErrorBox}>
                  <img src={process.env.PUBLIC_URL + `/static/images/icons/red-info-dark.svg`} alt="Icon" style={infoModalSxs?.imgBoxSx} />
                  <Typography sx={infoModalSxs?.noSelectionError}>
                    {isMinCharMissingError || isMinCharOtherError ? infoModalTexts?.charError : isOtherFieldError ? infoModalTexts?.otherReasonError : isLocalSeo ? infoModalTexts?.missingFeatureLocalSeoError : infoModalTexts?.missingFeatureError}
                  </Typography>
                </Box>
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default FeedbackOptions;
